<div>
  <div class="matter-sb-header" style="border-top: none" (click)="sidebarExpand.administration = !sidebarExpand.administration">
    <h5 class="font-weight-normal">
      <a style="font-size: 14px; padding-bottom: 4px" href="javascript: void(0)"><i [class]="'fa fa-' + (sidebarExpand.administration ? 'minus' : 'plus') + '-circle'"></i></a>&nbsp;&nbsp;Administration
    </h5>
  </div>
  <div class="matter-sb-content" [hidden]="!sidebarExpand.administration">
    <app-matter-administration [matter_id]="matter_id"></app-matter-administration>
  </div>
</div>
<div>
  <div class="matter-sb-header" (click)="sidebarExpand.billing_summary = !sidebarExpand.billing_summary">
    <h5 class="font-weight-normal">
      <a style="font-size: 14px; padding-bottom: 4px" href="javascript: void(0)"><i [class]="'fa fa-' + (sidebarExpand.billing_summary ? 'minus' : 'plus') + '-circle'"></i></a>&nbsp;&nbsp;Billing Summary
    </h5>
  </div>
  <div class="matter-sb-content" *ngIf="sidebarExpand.billing_summary">
    <app-matter-billing-summary [matter_id]="matter_id"></app-matter-billing-summary>
  </div>
</div>
<div>
  <div class="matter-sb-header" (click)="sidebarExpand.matter_dates = !sidebarExpand.matter_dates">
    <h5 class="font-weight-normal">
      <a style="font-size: 14px; padding-bottom: 4px" href="javascript: void(0)"><i [class]="'fa fa-' + (sidebarExpand.matter_dates ? 'minus' : 'plus') + '-circle'"></i></a>&nbsp;&nbsp;Dates
    </h5>
  </div>
  <div class="matter-sb-content" *ngIf="sidebarExpand.matter_dates">
    <app-matter-date-index [matter_id]="matter_id"></app-matter-date-index>
  </div>
</div>
<div>
  <div class="matter-sb-header" (click)="sidebarExpand.matter_details = !sidebarExpand.matter_details">
    <h5 class="font-weight-normal">
      <a style="font-size: 14px; padding-bottom: 4px" href="javascript: void(0)"><i [class]="'fa fa-' + (sidebarExpand.matter_details ? 'minus' : 'plus') + '-circle'"></i></a>&nbsp;&nbsp;Details
    </h5>
  </div>
  <div class="matter-sb-content" *ngIf="sidebarExpand.matter_details">
    <app-matter-detail-index [matter_id]="matter_id"></app-matter-detail-index>
  </div>
</div>
<div *ngIf="permissions.is_lead_attorney || permissions.is_admin || permissions.is_manager || permissions.is_staff">
  <div class="matter-sb-header" (click)="sidebarExpand.edit_matter = !sidebarExpand.edit_matter">
    <h5 class="font-weight-normal">
      <a style="font-size: 14px; padding-bottom: 4px" href="javascript: void(0)"><i [class]="'fa fa-' + (sidebarExpand.edit_matter ? 'minus' : 'plus') + '-circle'"></i></a>&nbsp;&nbsp;Edit Matter
    </h5>
  </div>
  <div class="matter-sb-content" *ngIf="sidebarExpand.edit_matter">
    <app-matter-edit-form [matter_id]="matter_id" (saveMatterEvent)="matterEditFormSaveEventHander($event)"></app-matter-edit-form>
  </div>
</div>
<div>
  <div class="matter-sb-header" (click)="sidebarExpand.events = !sidebarExpand.events">
    <h5 class="font-weight-normal d-flex align-items-center justify-content-between">
      <span>
        <a style="font-size: 14px; padding-bottom: 4px" href="javascript: void(0)"><i [class]="'fa fa-' + (sidebarExpand.events ? 'minus' : 'plus') + '-circle'"></i></a>&nbsp;&nbsp;Events
      </span>
      <a
        class="matter-sb-header-action"
        [routerLink]="'/events'"
        [queryParams]="{ new_event: true, matter_id: matter_id }"
        title="Create New Event"
        aria-label="Create New Event"
        (click)="$event.stopPropagation()"
      >
        <i class="fas fa-plus-circle"></i>
      </a>
    </h5>
  </div>
  <div class="matter-sb-content" *ngIf="sidebarExpand.events">
    <app-matter-events [matter_id]="matter_id"></app-matter-events>
  </div>
</div>
<div>
  <div class="matter-sb-header" (click)="sidebarExpand.exhibits = !sidebarExpand.exhibits">
    <h5 class="font-weight-normal">
      <a style="font-size: 14px; padding-bottom: 4px" href="javascript: void(0)"><i [class]="'fa fa-' + (sidebarExpand.exhibits ? 'minus' : 'plus') + '-circle'"></i></a>&nbsp;&nbsp;Exhibits
    </h5>
  </div>
  <div class="matter-sb-content" *ngIf="sidebarExpand.exhibits">
    <app-matter-exhibits [matter_id]="matter_id"></app-matter-exhibits>
  </div>
</div>
<div>
  <div class="matter-sb-header" (click)="sidebarExpand.matter_associations = !sidebarExpand.matter_associations">
    <h5 class="font-weight-normal">
      <a style="font-size: 14px; padding-bottom: 4px" href="javascript: void(0)"><i [class]="'fa fa-' + (sidebarExpand.matter_associations ? 'minus' : 'plus') + '-circle'"></i></a>&nbsp;&nbsp;Matter Associations
    </h5>
  </div>
  <div class="matter-sb-content" *ngIf="sidebarExpand.matter_associations">
    <app-matter-associations [matter_id]="matter_id"></app-matter-associations>
  </div>
</div>
<div #sidebarRecordTime *ngIf="permissions.is_matter_user">
  <div class="matter-sb-header" (click)="sidebarExpand.record_time = !sidebarExpand.record_time">
    <h5 class="font-weight-normal">
      <a style="font-size: 14px; padding-bottom: 4px" href="javascript: void(0)"><i [class]="'fa fa-' + (sidebarExpand.record_time ? 'minus' : 'plus') + '-circle'"></i></a>&nbsp;&nbsp;Record Time
    </h5>
  </div>
  <div class="matter-sb-content p-2" [hidden]="!sidebarExpand.record_time">
    <app-billing-record-time [matter_id]="matter_id"></app-billing-record-time>
  </div>
</div>
<div #sidebarDocument>
  <div class="matter-sb-header" (click)="sidebarExpand.documents = !sidebarExpand.documents">
    <h5 class="font-weight-normal">
      <a style="font-size: 14px; padding-bottom: 4px" href="javascript: void(0)"><i [class]="'fa fa-' + (sidebarExpand.documents ? 'minus' : 'plus') + '-circle'"></i></a>&nbsp;&nbsp;Documents
    </h5>
  </div>
  <div class="matter-sb-content" [hidden]="!sidebarExpand.documents">
    <app-document-sidebar [matter_id]="matter_id"></app-document-sidebar>
  </div>
</div>
<div>
  <div class="matter-sb-header" (click)="sidebarExpand.tags = !sidebarExpand.tags">
    <h5 class="font-weight-normal">
      <a style="font-size: 14px; padding-bottom: 4px" href="javascript: void(0)"><i [class]="'fa fa-' + (sidebarExpand.tags ? 'minus' : 'plus') + '-circle'"></i></a>&nbsp;&nbsp;Tags
    </h5>
  </div>
  <div class="matter-sb-content" *ngIf="sidebarExpand.tags">
    <app-matter-tags [matter_id]="matter_id"></app-matter-tags>
  </div>
</div>
<div>
  <div class="matter-sb-header" (click)="sidebarExpand.todos = !sidebarExpand.todos">
    <h5 class="font-weight-normal">
      <a style="font-size: 14px; padding-bottom: 4px" href="javascript: void(0)"><i [class]="'fa fa-' + (sidebarExpand.todos ? 'minus' : 'plus') + '-circle'"></i></a>&nbsp;&nbsp;Todos
    </h5>
  </div>
  <div class="matter-sb-content" *ngIf="sidebarExpand.todos">
    <app-todos [matter_id]="matter_id"></app-todos>
  </div>
</div>
<div *ngIf="permissions.is_lead_attorney || permissions.is_admin || permissions.is_manager || permissions.is_staff">
  <div class="matter-sb-header" (click)="sidebarExpand.matter_users = !sidebarExpand.matter_users">
    <h5 class="font-weight-normal">
      <a style="font-size: 14px; padding-bottom: 4px" href="javascript: void(0)"><i [class]="'fa fa-' + (sidebarExpand.matter_users ? 'minus' : 'plus') + '-circle'"></i></a>&nbsp;&nbsp;Users
    </h5>
  </div>
  <div class="matter-sb-content" *ngIf="sidebarExpand.matter_users">
    <app-matter-user-index [matter_id]="matter_id"></app-matter-user-index>
  </div>
</div>
